// extracted by mini-css-extract-plugin
export default {"root":"vsc02T","paper":"myBC7r"};